export default __webpack_public_path__ + "static/media/group_88.43c99df8.png";